import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { allFinishedWithSuccess, anyRequestsFailed } from '../utils/requestUtils';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
class LoadingWrapper extends PureComponent {
  render() {
    const {
      children,
      requestStatuses
    } = this.props;
    if (allFinishedWithSuccess(...requestStatuses) || anyRequestsFailed(...requestStatuses)) {
      return /*#__PURE__*/_jsx("div", {
        children: children
      });
    }
    return /*#__PURE__*/_jsx(UIFlex, {
      align: "center",
      justify: "center",
      children: /*#__PURE__*/_jsx(UILoadingSpinner, {
        layout: "centered"
      })
    });
  }
}
LoadingWrapper.propTypes = {
  children: PropTypes.node,
  requestStatuses: PropTypes.array.isRequired
};
export default LoadingWrapper;